"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');
var _pendingSends = require('shared/services/pendingSends');

// A send with files posts nothing until every file is up, so leaving the page
// meanwhile loses it. While one is uploading, closing or reloading the tab
// asks first, with the browser's own leave dialog (custom text is ignored).
//
// The desktop app (Electron) shows no dialog for a cancelled beforeunload; it
// just cancels the close or quit. Builds that ask on their own expose
// setUploadsPending, which this keeps up to date. Older builds lack it and get
// no warning at all rather than a close that silently does nothing.
const warnBeforeLeaving = (event) => {
  event.preventDefault()
  // Older browsers need returnValue set to show the dialog.
  event.returnValue = ''
}

 function useLeaveWarningWhileSending () {
  const sending = _pendingSends.useHasPendingSends.call(void 0, )
  _react.useEffect.call(void 0, () => {
    const desktop = window.ELECTRON
    _optionalChain([desktop, 'optionalAccess', _ => _.setUploadsPending, 'optionalCall', _2 => _2(sending)])
    if (!sending || (desktop && !desktop.setUploadsPending)) return undefined
    window.addEventListener('beforeunload', warnBeforeLeaving)
    return () => window.removeEventListener('beforeunload', warnBeforeLeaving)
  }, [sending])
} exports.default = useLeaveWarningWhileSending;
